import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import checkRestrictionUserAge from '../../../utils/userAgeRestriction.js';
import { steamPurchasePrepare } from '../../../api/platform/steam/steamPurchasePrepare.js';
import { steamPurchaseStatus } from '../../../api/platform/steam/steamPurchaseStatus.js';
import { purchaseFreeProduct } from '../../../api/purchase.js';
import { EVENTS } from '../../../constants/events.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import { PURCHASE_STATUSES } from '../../../constants/purchaseStatuses.js';
import { RESTRICTION_STATUTES } from '../../../constants/restrictionStatus.js';
import { STEAM_TRANSACTION_STATUSES } from '../../../constants/steam/steamTransactionStatuses.js';
import events from '../../event/index.js';
import { getCategories } from './categories.js';
import { getProducts } from './products.js';
import { getUser } from './user.js';
import settings from '../../../settings.js';
import { updateProductVariablePriceByQuantity } from '../../../store/products.js';
import { error, warn, log } from '../../../utils/logger.js';
import { redirectToUrl } from '../../../utils/redirectToUrl.js';

function checkout(externalProductId, customStorefrontName, quantity, customFields) {
    return __awaiter(this, void 0, void 0, function* () {
        const user = yield getUser();
        if (settings.redirectToUserAuthEnabled) {
            if (!user.isLoggedIn && settings.userAuthUrl) {
                redirectToUrl(settings.userAuthUrl);
                throw new Error('User not logged in');
            }
        }
        const productEntities = yield getProducts(customStorefrontName);
        let productEntity = productEntities.find((productEntity) => productEntity.externalProductId === externalProductId);
        if (!productEntity) {
            error('[Steam]', 'Product not found', externalProductId, productEntities);
            return { purchaseStatus: PURCHASE_STATUSES.ERROR };
        }
        if ((yield checkRestrictionUserAge(productEntity, events, user)) === RESTRICTION_STATUTES.CANCELLED) {
            return { purchaseStatus: PURCHASE_STATUSES.CANCELLED };
        }
        try {
            const storefrontName = customStorefrontName || settings.storefrontName;
            const productQuantity = quantity || 1;
            productEntity = yield updateProductVariablePriceByQuantity(productEntity, productQuantity, storefrontName, PLATFORMS.STEAM);
            const { code, currency, price } = productEntity;
            if (productEntity.price === 0) {
                events.emit(EVENTS.SET_FETCHING, { visibility: true });
                const purchaseResult = { purchaseStatus: PURCHASE_STATUSES.ERROR };
                try {
                    yield purchaseFreeProduct(productEntity, quantity, storefrontName);
                    productEntity.updateLimitAfterSuccessPurchase();
                    const categoryEntities = yield getCategories();
                    events.emit(EVENTS.PRODUCTS_UPDATE, { storefrontName, products: productEntities });
                    events.emit(EVENTS.CATEGORIES_UPDATE, { storefrontName, categories: categoryEntities });
                    purchaseResult.purchaseStatus = PURCHASE_STATUSES.SUCCESS;
                }
                catch (e) {
                    warn('Failed to purchase a free product', e);
                }
                finally {
                    events.emit(EVENTS.SET_FETCHING, { visibility: false });
                }
                return purchaseResult;
            }
            const STEAM_STATUS_MAP = {
                [STEAM_TRANSACTION_STATUSES.SUCCEEDED]: PURCHASE_STATUSES.SUCCESS,
                [STEAM_TRANSACTION_STATUSES.CANCELLED]: PURCHASE_STATUSES.CANCELLED,
                [STEAM_TRANSACTION_STATUSES.EXPIRED]: PURCHASE_STATUSES.ERROR,
            };
            log('[Steam]', 'Create transaction with params', code, currency, storefrontName);
            const { transactionId } = yield steamPurchasePrepare(code, productQuantity, currency, price, storefrontName);
            log('[Steam]', 'Received transaction id', transactionId);
            const { status } = yield steamPurchaseStatus(transactionId);
            if (status === STEAM_TRANSACTION_STATUSES.SUCCEEDED) {
                log('[Steam]', 'Received purchase status', status, STEAM_STATUS_MAP[status]);
                productEntity.updateLimitAfterSuccessPurchase();
                const categoryEntities = yield getCategories();
                events.emit(EVENTS.PRODUCTS_UPDATE, { storefrontName, products: productEntities });
                events.emit(EVENTS.CATEGORIES_UPDATE, { storefrontName, categories: categoryEntities });
            }
            return { purchaseStatus: STEAM_STATUS_MAP[status] };
        }
        catch (err) {
            error('[Steam]', 'Purchase has been finished with error', err);
        }
        return { purchaseStatus: PURCHASE_STATUSES.ERROR };
    });
}

export { checkout };
//# sourceMappingURL=checkout.js.map
